export type IAuthCacheKeyData = {
  clientId: string;
  sessionId: string;
};

export type IAuthCacheKeyOptions = {
  prefix?: string;
};

/**
 * Key object for the authentication cache. Currently, each key is namespaced by
 * the client ID, which is required. In the future, we may want to add more
 * specific namespaces to the key, like a scope.
 */
export class AuthCacheKey {
  public clientId: string;
  public sessionId: string;

  public constructor(
    data: IAuthCacheKeyData,
    public suffix?: string,
  ) {
    this.clientId = data.clientId;
    this.sessionId = data.sessionId;
  }

  /**
   * Converts this `AuthCacheKey` instance into a string for use in a cache.
   * @returns A string representation of the key
   */
  public toString(): string {
    return [this.clientId, this.sessionId, this.suffix]
      .filter(Boolean)
      .join('::');
  }

  /**
   * Build a `AuthCacheKey` instance from a cache key.
   * @param key - The key to convert
   * @returns An instance of `AuthCacheKey`
   */
  public static fromString(key: string): AuthCacheKey {
    const [clientId, sessionId, suffix] = key.split('::');

    return new AuthCacheKey({ clientId, sessionId }, suffix);
  }
}
